<template>
  <div class="demo-app" :class="{ active: this.demoActive == true }">
    <div class="flex items-start w-full">
      <!-- {{CalendarApi}} -->
      <!-- {{name}} -->
      <vs-card class="demo-app-sidebar">
        <button @click="openMenubar" class="nav-btn">
          <span class="material-icons">chevron_right</span>
        </button>
        <div class="leftSidebarContent">
          <div class="childInherit">
            <!-- <vs-input
              class="inputx w-full"
              placeholder="Search"
              v-model="search"
            /> -->
          </div>
          <FilterCheckbox @filterSchedule="filterSchedule" type="default" />

          <strong class="block text-lg my-2">{{ name }}</strong>


          <ul class="leftx name-list p-0">
            <li class="relative">
              <vs-checkbox
                v-if="courseList.length"
                v-model="allCourse"
                @change="filterAllCourse"
                >All Course</vs-checkbox
              >
              <span v-else>No Course</span>
            </li>
          </ul>
          <div style="max-height: calc(100vh - 205px); overflow: auto;" class="vertical_scrollbar">
            <ul class="leftx name-list p-0">
              <li
                class="relative"
                v-for="(eachCourse, index) in courseList"
                :key="index"
              >
                <vs-checkbox
                  v-model="eachCourse.isActive"
                  @change="filterEvent()"
                >
                  <div class="img-holder">
                    <img
                      v-if="eachCourse.picture!=null"
                      :src="eachCourse.picture"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      src="https://scoolio-alpha.s3.eu-west-2.amazonaws.com/default_course_image.png"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </div>
                  <span class="pl-14 inline-block">
                    {{ eachCourse.name }}
                  </span></vs-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-card>

      <div class="demo-app-main">
        <vs-card>
          <!-- <pre>{{arg}}</pre>  -->
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="calendar"
            @datesRender="handleMonthChange"
          >
            <!-- Hello -->
            <template v-slot:eventContent="arg">
              <div class="w-full" v-if="arg">
                <vs-tooltip :text="arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title">
                  <!-- <div class="falex items-center p-1 event-card" :style="{backgroundColor:arg.event.backgroundColor, color:arg.event.extendedProps.cstmcolor}"> -->
                  <div class="event-card">
                    <!-- <img
                      src="/img/avatar-s-11.1a620230.jpg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md block mr-1"
                    /> -->
                    <div class="flex items-center">
                      <div
                        class="indicator"
                        :style="{ backgroundColor: arg.event.backgroundColor }"
                      ></div>
                      <!-- <feather-icon icon="ClockIcon" /> -->
                      <b>{{ arg.timeText }}</b>
                      <!-- <feather-icon icon="UserIcon" /> -->
                      <b class="limitTitle"
                        ><i>{{ arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title }}</i></b
                      >
                      <p>
                        <i>{{ arg.location }}</i>
                      </p>
                    </div>
                  </div>
                </vs-tooltip>
              </div>
            </template>

            <!-- <template #eventContent="{ timeText, event }">
                     <pre></pre>
                    <b>{{ timeText }}</b>
                    <i>{{ event.title }}</i>
                </template> -->
          </FullCalendar>
        </vs-card>
      </div>
    </div>

    <!-- edit modal -->
    <div v-if="eachEventPopUp">
       <div
        class="
          vs-component
          con-vs-popup
          vs-popup-primary
          cstm-modal-popup
          schedule-popup
        "
        v-if="eachEventPopUp"
        :class="{ show: eachEventPopUp }"
      >
        <div class="cstm-modal">
          <div class="header">
            <button @click="eachEventPopUp = false" class="close-modal">
              &times;
            </button>
          </div>
          <div class="modal-content">
            <event-detail
              :eachEventInfo="eachEventInfo"
              :name="name"
              tabType="student"
              @editedSchedule="editedSchedule"
            ></event-detail>
          </div>
        </div>
      </div>
    </div> 
    <div v-if="classPopup">
       <div
        class="
          vs-component
          con-vs-popup
          vs-popup-primary
          cstm-modal-popup
          schedule-popup
        "
        v-if="classPopup"
        :class="{ show: classPopup }"
      >
        <div class="cstm-modal">
          <div class="header">
            <button @click="classPopup = false" class="close-modal">
              &times;
            </button>
          </div>
          <div class="modal-content">
            <class-event-detail
              :classPopup="classPopup"
              :class_id="class_id"
              :eventDetails="eventDetails"
            ></class-event-detail>
          </div>
        </div>
      </div>
    </div>

    <!-- adding event modal -->
    <!--  <div v-if="eventAdding">
      <vs-popup class="holamundo" title="Add Event" :active.sync="eventAdding">
        <add-event
          @createEvent="createEvent"
          :startDate="startDate"
          :endDate="endDate"
        ></add-event>
      </vs-popup>
    </div> -->
  </div>
</template>
<script>

import FilterCheckbox from './components/FilterCheckbox.vue'


import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './components/AddEvent'
import Testing from './components/Testing'

import EventDetail from '@/views/pages/schedule/studentEventDetails'
import ClassEventDetail from '@/views/pages/schedule/components/ClassEventDetails.vue'
import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from './mixins/eventMixin'
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    EventDetail,
    editor: Editor,
    Testing,
    FilterCheckbox,
    ClassEventDetail
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true,
      eachEventPopUp: false
    },
    customer_id: {
      type: Number,
      required: true
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API


    this.fetchingEvent(null, 'default')
  },
  watch: {
    customer_id () {
      this.fetchingCourseList()

      const year = this.calendarApi.getDate().getFullYear()
      const month = this.calendarApi.getDate().getMonth() + 1 //jan = 0
      const monthString = String(month).padStart(2, 0) // 0009

      const payload = {
        type: 'default',
        year,
        month: monthString
      }
      this.fetchingEvent(payload, 'default')
    }
  },
  mounted () {
    this.calendarApi = this.$refs.calendar.getApi()
    this.fetchingCourseList()
  },
  data () {
    return {
      class_id:null,
      classPopup: false,
      search: 'sad',
      eventDetails:null,
      event: null,
      startDate: null,
      endDate: null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      // radios1: [],
      eachEventInfo: null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        customButtons: {
          previousButton: {
            text: '<',
            click: () => {
              this.previousMonth('default')
            }
          },
          nextButton: {
            text: '>',
            click: () => {
              this.nextMonth('default')
            }
          },
          todayButton: {
            text: 'Today',
            click: () => {
              this.today('default')
            }
          }
        },
        headerToolbar: {
          left: 'previousButton,nextButton todayButton',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventLimit: false, // for all non-TimeGrid views
        events: [],
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        
        dayMaxEvents: true,
        eventTimeFormat: {
          // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,

        eventsSet: this.handleEvents

        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      allCourse: true,

      currentEvents: [],
      demoActive: false,
      schedulingList: [],
      eachMonthEventData: [],
      calendarApi: '',
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ]
    }
  },
  methods: {
    editedSchedule () {
      this.eachEventPopUp = false

      const payload = this.creatingPayload('default')
      this.fetchingEvent(payload, 'default')
    },
    getCourseLabel (coursetype) {
      const index = this.course_class_type_list.findIndex((ele) => {
        return ele.value === coursetype
      })

      if (index >= 0) {
        return this.course_class_type_list[index].name
      }

      return coursetype
    },
    handleMonthChange (arg) {
      console.log(arg)
    },
    changeMonth (start, end) {
      console.log(start, end)
    },
    // getContrast (hexcolor) {
    //
    //   hexcolor = hexcolor.replace('#', '')
    //   const r = parseInt(hexcolor.substr(0, 2), 16)
    //   const g = parseInt(hexcolor.substr(2, 2), 16)
    //   const b = parseInt(hexcolor.substr(4, 2), 16)
    //   const yiq = (r * 299 + g * 587 + b * 114) / 1000
    //   return yiq >= 128 ? '#000000' : '#ffffff'
    // },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {
      this.startDate = selectInfo.startStr
      this.endDate = selectInfo.endStr
      this.eventAdding = true
    },
    handleEventClick (clickInfo) {
      this.abc = 'b'
      this.eachEventInfo = clickInfo.event
      if (clickInfo.event.title !== null && clickInfo.event.title !== '') {
        this.eachEventPopUp = true
      } else {
        console.log(clickInfo.event)
        this.classPopup = true
        this.class_id = clickInfo.event.extendedProps.course.class_id
        this.eventDetails = clickInfo.event
      }
      
    },
    handleEvents (events) {
      this.currentEvents = events
    },
    createEvent (obj) {
      console.log(obj)
      INITIAL_EVENTS.push({
        id: createEventId(),
        title: obj.title,
        start: `${obj.course_start} ${obj.course_start_time}`,
        // startTime: obj.course_start_time,
        end: `${obj.course_end} ${obj.course_end_time}`,
        backgroundColor: obj.eventTextColor,
        location: obj.location,
        eventTypePicked: obj.eventTypePicked
      })
      this.showSuccessMessage('Success', 'Event Added Successfully', 'success')
      setTimeout(() => {
        this.eventAdding = false
      }, 0)
      /*   setTimeout(() => {
        this.eventAdding = false

      }, 1000) */

      // this.$refs.calendar.$emit('refetch-events')
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}
.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf;
  color: #fff;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>
